import React from 'react'
import { isNotEmpty } from '../utils'
import { AlertEmpty } from './alert'

const ArrayChecker = ({data, children}) => {
  return <>
    { data !== undefined && isNotEmpty(data) ? children : <AlertEmpty /> }
  </>
}

export { ArrayChecker }
